import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getContent } from '@plone/volto/actions/content/content';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';

// Unsaved image selections need the same asset credit as the serialized page.
export default function useImageCopyright(url, fallback) {
  const dispatch = useDispatch();
  const [asset, setAsset] = useState();
  useEffect(() => {
    let active = true;
    if (url && isInternalURL(url)) {
      dispatch(getContent(flattenToAppURL(url), null, `image-credit-${url}`))
        .then(async (content) => {
          const preview = content.preview_image_link?.['@id'];
          const image = preview
            ? await dispatch(
                getContent(
                  flattenToAppURL(preview),
                  null,
                  `image-credit-${preview}`,
                ),
              )
            : content;
          if (active) setAsset({ url, credit: image.rights || '' });
        })
        .catch(() => {
          if (active) setAsset({ url, credit: '' });
        });
    }
    return () => {
      active = false;
    };
  }, [url, dispatch]);
  return url ? (asset?.url === url ? asset.credit : '') : fallback;
}
